<!-- Navbar -->
<nav
  class="main-header auction-header navbar navbar-expand navbar-light border-0"
>
  <!-- Left navbar links -->
  <ul class="navbar-nav">
    <li class="nav-item">
      <a
        href="javascript:void(0)"
        class="nav-link"
        (click)="toggleMenuSidebar.emit()"
      >
        <i class="las la-bars ion-2x"></i>
      </a>
    </li>
  </ul>

  <!-- Right navbar links -->
  <ul class="navbar-nav auction-header-list ml-auto">
    <li class="nav-item auction-header-item dropdown" dropdown>
      <a
        href="javascript:void(0)"
        class="nav-link auction-header-link"
        dropdownToggle
      >
        <ion-icon name="notifications" class="ion-2x"></ion-icon>
        <span class="notification-marker"></span>
      </a>

      <div
        class="dropdown-menu dropdown-menu-lg dropdown-menu-right"
        *dropdownMenu
      ></div>
    </li>
    <li class="nav-item auction-header-item">
      <a class="nav-link auction-header-link" routerLink="/">
        <i class="las la-sign-out-alt ion-2x" (click)="Logout()"></i>
      </a>
    </li>

    <li class="nav-item auction-header-item user-dropdown dropdown" dropdown>
      <a
        href="javascript:void(0)"
        class="nav-link auction-header-link"
        dropdownToggle
      >
        {{loggedUsername || 'Admin'}}
        <i class="las la-angle-down dropdown-arrow mx-2"></i>
        <span class="user-pf">
          <img [src]="userDetails?.['profileImageUrl']?.['presigned_url'] || env+'assets/img/default-profile.png'" alt="" class="user-pf-img" />
        </span>
      </a>

      <div
        class="dropdown-menu dropdown-menu-lg dropdown-menu-right"
        *dropdownMenu
      >
        <ul class="list-unstyled px-3">
          <li class="curser-pointer" (click)="Logout()">Logout</li>
        </ul>
      </div>
    </li>
  </ul>
</nav>
<!-- /.navbar -->

